module.exports = __webpack_public_path__ + "static/img/7_10commitments_3.5percent.88849f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/7_10commitments_3.5percent.jpg
// module id = aQFW
// module chunks = 0